// components/subscription/SubscriptionCheckout.jsx
import React, { useState } from 'react';
import { useSubscription } from '../../contexts/SubscriptionContext';
import CouponForm from './CouponForm';


const SubscriptionCheckout = ({ planId, onSuccess, onCancel }) => {
  const { subscribe, getPlanById, loading, error } = useSubscription();
  const [coupon, setCoupon] = useState(null);
  // const [totalValue, setTotalValue] = useState();
  // const [paymentMethod, setPaymentMethod] = useState('card');
  
  const plan = getPlanById(planId);
  
  if (!plan) {
    return <div className="text-center py-8 text-red-600">Plan not found</div>;
  }

  const handleCouponApply = (couponData) => {
    setCoupon(couponData);
    console.log('Coupon applied:', coupon);
  };

  const calculateTotal = () => {
    if (!plan) return 0;
    let total = plan.price;
    if (coupon && coupon.discount_percentage) {
      total = total * (1 - coupon.discount_percentage / 100);
    }
    // setTotalValue(totalValue);
    return total;
  };

  const handleSubmit = async (e) => {
    e.preventDefault();
    try {
      const orderData = await subscribe(planId, coupon?.coupon_code);
      console.log('Order data:', orderData);
      // This would typically open Razorpay checkout
      // In a real implementation, you'd handle Razorpay integration here
      const options = {
        key: process.env.REACT_APP_RAZORPAY_KEY_ID,
        amount: orderData.amount,
        currency: orderData.currency,
        name: 'Your Company Name',
        description: `Subscription to ${plan.name}`,
        order_id: orderData.order_id,
        coupon_code: coupon?.code || '',
        handler: function(response) {
          // Verify payment on the backend
          // Once verified, call onSuccess
          onSuccess({response, plan_id: planId, coupon_code: coupon?.coupon_code});
        },
        prefill: {
          name: 'Customer Name',
          email: 'customer@example.com',
          contact: '9999999999'
        },
        notes: {
          plan_id: planId,
          coupon_code: coupon?.code || ''
        },
        theme: {
          color: '#3399cc'
        }
      };
    
      console.log('Opening razorpay window with Options as', options);
      // In a real app, you'd load Razorpay and open the checkout
      const razorpay = new window.Razorpay(options);
      razorpay.open();
      
      console.log('Razorpay payment done');

      // render to window.location.href = '/Overview'

      // For demo purposes, just simulate success
      // setTimeout(() => {
      //   onSuccess({
      //     razorpay_payment_id: 'pay_' + Math.random().toString(36).substr(2, 9),
      //     razorpay_order_id: orderData.id,
      //     razorpay_signature: 'signature',
      //     plan_id: planId,
      //     coupon_code: coupon?.code
      //   });
      // }, 1000);
      
    } catch (err) {
      // Error is handled by the context
      console.log(`Error in Razorpay: ${err}`)
    }
  };

  return (
    <div className="bg-white border border-gray-200 rounded-lg p-6">
      <h2 className="text-xl font-semibold mb-4">Checkout</h2>
      
      <div className="mb-6">
        <h3 className="text-lg font-medium mb-2">Order Summary</h3>
        <div className="bg-gray-50 p-4 rounded-lg">
          <div className="flex justify-between mb-2">
            <span>Plan:</span>
            <span className="font-medium">{plan.name}</span>
          </div>
          <div className="flex justify-between mb-2">
            <span>Duration:</span>
            <span>{plan.period === 1 ? '1 month' : `${plan.period} months`}</span>
          </div>
          <div className="flex justify-between mb-2">
            <span>Price:</span>
            <span>₹{parseFloat(plan.price).toFixed(2)}</span>
          </div>
          
          {coupon && (
            <div className="flex justify-between mb-2 text-green-700">
              <span>Discount ({coupon.discount_percentage}%):</span>
              <span>-₹{(plan.price * coupon.discount_percentage / 100).toFixed(2)}</span>
            </div>
          )}
          
          <div className="border-t border-gray-300 my-2 pt-2 flex justify-between font-bold">
            <span>Total:</span>
            <span>₹{parseFloat(calculateTotal()).toFixed(2)}</span>
          </div>
        </div>
      </div>
      
      <CouponForm planId={planId} onApply={handleCouponApply} />
      {/*       
      <div className="mt-6">
        <h3 className="text-lg font-medium mb-3">Payment Method</h3>
        <div className="space-y-3">
          <div 
            className={`border rounded-md p-3 flex items-center cursor-pointer ${
              paymentMethod === 'card' ? 'border-blue-500 bg-blue-50' : 'border-gray-200'
            }`}
            onClick={() => setPaymentMethod('card')}
          >
            <input 
              type="radio" 
              checked={paymentMethod === 'card'} 
              onChange={() => setPaymentMethod('card')} 
              className="mr-3"
            />
            <div>Credit / Debit Card</div>
          </div>
          
          <div 
            className={`border rounded-md p-3 flex items-center cursor-pointer ${
              paymentMethod === 'upi' ? 'border-blue-500 bg-blue-50' : 'border-gray-200'
            }`}
            onClick={() => setPaymentMethod('upi')}
          >
            <input 
              type="radio" 
              checked={paymentMethod === 'upi'} 
              onChange={() => setPaymentMethod('upi')} 
              className="mr-3"
            />
            <div>UPI</div>
          </div>
        </div>
      </div> */}
      
      {error && <div className="mt-4 text-sm text-red-600">{error}</div>}
      
      <div className="mt-6 flex space-x-4">
        <button
          onClick={onCancel}
          className="px-4 py-2 border border-gray-300 rounded-md hover:bg-gray-50"
        >
          Cancel
        </button>
        <button
          onClick={handleSubmit}
          disabled={loading}
          className="flex-1 px-4 py-2 bg-blue-600 text-white rounded-md hover:bg-blue-700 disabled:opacity-50"
        >
          {loading ? 'Processing...' : `Pay ₹${parseFloat(calculateTotal()).toFixed(2)}`}
        </button>
      </div>
    </div>
  );
};

export default SubscriptionCheckout;